import React, { memo, useState } from 'react'
import MaterialTable from 'material-table'
import '../../styles/tableMaterialStyle.css'
import {
   Button,
   Grid,
   makeStyles,
   TablePagination,
   Typography
} from '@material-ui/core'
import moment from 'moment'
import TableCell from '../../commons/TableCell'
import Active from '../../commons/Active'
import Inactive from '../../commons/Inactive'
import TableActionPopover from '../../commons/TableActionPopover'
import { useStateValue } from 'context/store'
import { OPERACIONES_ROLES, VALUES } from 'utils/constants'
// import ResultsTable from 'components/ResultsTable'
import TableToolbar from 'components/commons/TableToolbar'
import { useHasOperation } from 'hooks/useHasOperation'

const RoleTable = ({
   dataTable,
   params = { size: 5 },
   // sortingStatus,
   newParams,
   isSearch = true,
   formData,
   setFormBehavior,
   // formBehavior,
   order,
   setIsPopoverOpen,
   resetForm: cleanCallback,
   actionEdit,
   header = true,
   parentChildData = undefined,
   customActions = undefined
}) => {
   const columns = [
      {
         title: 'NOMBRE ROL',
         field: 'name',
         align: 'center',
         sorting: !!isSearch,
         customSort: () => 0,
         // defaultSort: columnOrder, // TODO debe llegar como parámetro
         render: rowData => <TableCell text={rowData?.name} />
      },
      {
         title: 'DESCRIPCIÓN ROL',
         field: 'description',
         align: 'center',
         sorting: false,
         render: rowData => <TableCell text={rowData?.description} />
      },
      {
         title: 'ESTADO ROL',
         field: 'status',
         align: 'center',
         sorting: false,
         render: rowData =>
            rowData?.status === 'A' ? <Active /> : <Inactive />
      },
      {
         title: 'VIGENCIA INICIAL',
         field: 'initialDate',
         sorting: false,
         align: 'center'
      },
      {
         title: 'VIGENCIA FINAL',
         field: 'finalDate',
         sorting: false,
         align: 'center'
      },
      {
         title: 'DOMINIO',
         field: 'domain',
         render: rowData => getDomainName(rowData.domain),
         sorting: false,
         align: 'center'
      },
      {
         title: 'FECHA REGISTRO',
         field: 'createdDate',
         sorting: false,
         align: 'center'
      },
      {
         title: 'USUARIO REGISTRO',
         field: 'createdBy',
         sorting: false,
         align: 'center'
      }
   ]

   const VER_CODIGO = useHasOperation(OPERACIONES_ROLES.VER_CODIGO)
   const EDITAR_ROLES = useHasOperation(OPERACIONES_ROLES.EDITAR)

   const getDomainName = name => {
      if (name === 'PRIVATE') {
         return 'Privado'
      }
      if (name === 'EXTENDED') {
         return 'Extendido'
      }
      if (name === 'EXTERNAL') {
         return 'Externo'
      }
   }

   const changePage = (e, page) => {
      newParams({
         ...params,
         page
      })
   }

   const changeRowsPerPage = size => {
      newParams({
         ...params,
         size
      })
   }

   const getOrderAndIdColumn = (orderedColumnId, orderDirection) => {
      const nameColumn = state.columns[orderedColumnId].field
      newParams({
         ...params,
         columnOrder: nameColumn,
         order:
            params?.columnOrder === nameColumn && params?.order === 'ASC'
               ? 'DESC'
               : 'ASC'
      })
   }

   const [{ sessionUser }] = useStateValue()
   const userSettings = sessionUser?.settings
   const isInternalAdmin =
      userSettings?.isAdmin && userSettings?.type === VALUES.USER_TYPE.INTERNAL

   // if (!dataTable.length) {
   //     return <Typography >No hay registros que mostrar</Typography>
   // }
   return (
      <div>
         <MaterialTable
            options={{
               // actionsColumnIndex: -1,
               // toolbar: isSearch ? true : false,
               // paging: isSearch ? true : false,
               // emptyRowsWhenPaging: false,

               // rowStyle: {
               //     textAlign: 'center',
               //     backgroundColor: '#FFF'
               // }
               actionsColumnIndex: -1,
               toolbar: isSearch,
               paging: isSearch,
               emptyRowsWhenPaging: false,
               header,
               headerStyle: {
                  textTransform: 'uppercase',
                  fontWeight: 400,
                  textAlign: 'center',
                  fontSize: '12px',
                  lineHeight: '16px',
                  borderTop: !isSearch ? '4px solid #3264DC' : ''
               },
               rowStyle: {
                  textAlign: 'center',
                  backgroundColor: '#FFF'
               }
            }}
            columns={columns}
            data={dataTable.hasOwnProperty('data') ? dataTable.data : dataTable}
            parentChildData={parentChildData}
            actions={[
               EDITAR_ROLES ? {
                  icon: 'edit',
                  tooltip: 'Editar rol',
                  onClick: (event, rowData) => {
                     setIsPopoverOpen(true)

                     const initialDate = moment(
                        rowData.initialDate,
                        'DD-MM-YYYY'
                     ).format('YYYY-MM-DDThh:mm:ssZ')
                     const date = moment(
                        rowData.finalDate,
                        'DD-MM-YYYY'
                     ).format('YYYY-MM-DDThh:mm:ssZ')

                     const finalDate = moment(date).isValid() ? date : null

                     if (formData) {
                        formData.id = rowData?.id
                        formData.name = rowData?.name
                        formData.description = rowData?.description
                        formData.status = rowData?.status
                        formData.initialDate = initialDate
                        formData.finalDate = finalDate
                        formData.domain = rowData?.domain
                     }

                     setFormBehavior({
                        search: false,
                        register: false,
                        edit: true
                     })
                  }
               } : null,
               rowData => ({
                  icon: () =>
                     (rowData.code && isInternalAdmin) || VER_CODIGO ? (
                        <TableActionPopover data={rowData.code} />
                     ) : null
               })
            ]}
            style={{
               marginBottom: '80px',
               marginTop: '16px',
               marginRight: '5px',
               width: '100%'
            }}
            localization={{
               header: {
                  actions: 'ACCIÓN'
               },
               toolbar: {
                  searchTooltip: 'Buscar',
                  searchPlaceholder: 'Buscar'
               },
               body: {
                  emptyDataSourceMessage: (
                     <div>
                        <p className="not-found-text">
                           No hay coincidencia para esta consulta
                        </p>
                     </div>
                  )
               },
               pagination: VALUES.PAGINATION_CONFIG
            }}
            components={{
               Pagination: props => (
                  <TablePagination
                     {...props}
                     rowsPerPage={dataTable.pageSize ?? 5}
                     count={dataTable.totalRows ?? 0}
                     page={dataTable.pageNumber ?? 0}
                     totalRows={dataTable.totalRows ?? 0}
                     onChangePage={changePage}
                     onChangeRowsPerPage={event => {
                        props.onChangeRowsPerPage(event)
                        changeRowsPerPage(event.target.value)
                     }}
                  />
               ),
               // Toolbar: props => (
               //     <Grid
               //         className={classes.toolbar}
               //         container
               //         direction="row"
               //         justify="space-between"
               //         alignItems="center"
               //     >
               //         <Grid item xs={9} justify="flex-start">
               //             <p className={classes.titleTable}>
               //                 Resultados de la búsqueda
               //             </p>
               //         </Grid>
               //         <Grid
               //             item
               //             xs={3}
               //             justify="flex-end"
               //             style={{ textAlign: 'right', paddingRight: '10px' }}
               //         >
               //             <Button
               //                 className={classes.button}
               //                 variant="outlined"
               //                 color="primary"
               //                 onClick={cleanCallback}
               //             >
               //                 LIMPIAR
               //             </Button>
               //         </Grid>
               //     </Grid>
               // )
               Toolbar: props => (
                  <TableToolbar {...props} cleanCallback={cleanCallback} />
               )
            }}
            onOrderChange={getOrderAndIdColumn}
         />
         {/* <ResultsTable
                columns={state.columns}
                tableData={dataTable}
                isSearch={isSearch}
                searchCallback={getOrderAndIdColumn}
                cleanCallback={cleanCallback}
                actionEdit={actionEdit}
                order={order}
            /> */}
      </div>
   )
}

export default memo(RoleTable)
